<template>
  <div>
    <DxTabs
      :data-source="tabs"
      :selected-index.sync="selectedIndex"
      :focus-state-enabled="false"
    />
    <WeekPlan v-if="selectedIndex === 0" />
    <WipWeekPlan v-if="selectedIndex === 1" />
  </div>
</template>

<script>
import ConstDef from '../../../../MesSmartVue/src/share/ConstDef'
import DxTabs from 'devextreme-vue/tabs'
import WipWeekPlan from './WipWeekPlan'
import WeekPlan from './WeekPlan'

export default {
  name: 'BomTab',
  components: {
    DxTabs,
    WipWeekPlan,
    WeekPlan
  },
  data: function () {
    return {
      selectedIndex: 0,
      tabs: [
        {
          id: 0,
          text: '완제품 주간계획'
        },
        {
          id: 1,
          text: '다공정 주간계획'
        }
      ]
    }
  },
  created () {
    document.title = ConstDef.TAB_TITLE
    const user = this.$store.getters.getUserInfo
    console.log(user)
    if (user === undefined || user === null) {
      this.$router.push('/')
    }
  },
  mounted () {

  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {

  }
}
</script>

<style lang="scss">
  .notactive {
    display: none
  }
  .dx-tab-text{
    .dx-icon {
      margin-top: -8px!important;
    }
  }
</style>
